import { DEFAULT_LOCALE } from "../i18n";

/**
 * Generates the base path without the locale prefix.
 * e.g., '/es/moonpay/' -> '/moonpay/', '/moonpay/' -> '/moonpay/', '/' -> '/'
 */
export const getBasePath = (pathname: string, currentLocale: string): string => {
    // If current locale is default (en), the pathname already is the base path
    if (currentLocale === DEFAULT_LOCALE) {
      return pathname;
    }
  
    // Remove the locale prefix from the pathname
    const localePrefix = `/${currentLocale}/`;
    if (pathname.startsWith(localePrefix)) {
      return pathname.slice(localePrefix.length - 1) || '/';
    }
  
    // If pathname is just the locale root (e.g., '/es/')
    if (pathname === `/${currentLocale}/`) {
      return '/';
    }
  
    return pathname;
  };
  